import { defaultProfile } from '@/shared/constants'
import {
    getApiFavorites,
    markApiFavoriteItem,
    unMarkApiFavoriteItem,
    updateApiFavoritesChannel,
} from './FavoritesService'
import Channel from '@/clients/toya/classes/channels/channel'
import { ProductTypeVOD } from '@/types/vod/vodContentTypes'

export type ProductTypeToya =
    | ProductTypeVOD
    | 'web'
    | 'channel'
    | 'external'
    | 'cat'

export const getFavorites = async (profileId: string) => {
    if (profileId === defaultProfile.id) return
    return getApiFavorites(profileId)
}

export const updateFavoritesChannel = async (
    channels: Channel[],
    profileId: string
) => {
    {
        if (profileId === defaultProfile.id) return
        else return updateApiFavoritesChannel(channels, profileId)
    }
}

export const markFavoriteItem = async (
    profileId: string,
    productType: string,
    productId: string
) => {
    {
        if (profileId === defaultProfile.id) return
        else return markApiFavoriteItem(profileId, productType, productId)
    }
}

export const unMarkFavoriteItem = async (
    profileId: string,
    productType: string,
    productId: string
) => {
    if (profileId === defaultProfile.id) return
    else return unMarkApiFavoriteItem(productId, profileId, productType)
}

const FavoritesRepositoryToya = {
    getFavorites,
    updateFavoritesChannel,
    markFavoriteItem,
    unMarkFavoriteItem,
}

export default FavoritesRepositoryToya
